<template>
  <div class="col-12" id="dastresiposts">
    <div class=" mt-2">
      <div class=" text-right text-bold bg-light outline-r-card"
        style="background: var(--sidebar-bg-color) !important;">
        <div class="row">
          <div class="col-6 col-md-12 text-center p-3">
            <a class="m-0" @click="showNewItem = !showNewItem" style="cursor: pointer">
              اضافه کردن دسترسی جدید
            </a>
          </div>
        </div>
      </div>
      <div class=" collapsed p-2 slidetoggle outline-r-card" Id="newItem"
        style="background: var(--sidebar-bg-color) !important;" v-if="showNewItem">
        <div>
          <p>اضافه کردن حق دسترسی برای : {{ jobName }}</p>
          <div class="row">
            <div class="col-6">
              <label>ایجاد دسترسی برای سمت:</label>
              <SearchableCombo :edit="false" :code="null" @ResultCombo="getGrp" :action="'TblCombo/GettblGrp'"
                :method="'Get'" :queryString="{ id: 4 }" :idinput="'TblProductsId'" :keyItem="'getGrp'"
                :disabled="false">
              </SearchableCombo>
            </div>
            <div class="col-6">
              <label>ایجاد دسترسی برای شعبه:</label>
              <SearchableCombo :edit="false" :code="null" @ResultCombo="getShobe" :action="'TblCombo/GettblShobe'"
                :method="'Get'" :queryString="{ id: 4 }" :idinput="'TblProductsId'" :keyItem="'getShobe'"
                :disabled="false">
              </SearchableCombo>
            </div>
            <div class="col-12 d-flex justify-content-center">
              <button class="btn btn-success col-5 float-left" @click="createAccess()">
                ایجاد دسترسی
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div v-for="(item, key, index) in list.BvfrmDastresiPost" :key="item.Id" class="card mt-2">
      <div class="card-header text-right text-bold bg-light outline-r-card"
        style="background: var(--sidebar-bg-color) !important;">
        <div class="row">
          <div class="col-6 col-md-3">[ {{ item.Post }} ]</div>
          <div class="col-6 col-md-9 text-left">
            <a class="m-0" @click="
            toggle(item.Id);" style="cursor: pointer">
              مشاهده جزئیات
            </a>
          </div>
        </div>
      </div>
      <div class="card-body collapsed pt-0 pb-0 slidetoggle outline-r-card" :Id="item.Id"
        style="background: var(--sidebar-bg-color) !important;">
        <div class="row ml-3 mt-0 mr-3 pr-2 pl-2 h-100">
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>مشاهده مشتری</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanViewInfo' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanViewInfo
                    " v-model="editItem.tblTafsiliTypeGrp[key].canViewInfo" />
                  <label class="custom-control-label Pointer float-right" :for="'CanViewInfo' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>ایجاد مشتری</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanInsertInfo' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanInsertInfo
                    " v-model="editItem.tblTafsiliTypeGrp[key].canInsertInfo" />
                  <label class="custom-control-label Pointer float-right" :for="'CanInsertInfo' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>اصلاح مشتری</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanEditInfo' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanEditInfo
                    " v-model="editItem.tblTafsiliTypeGrp[key].canEditInfo" />
                  <label class="custom-control-label Pointer float-right" :for="'CanEditInfo' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>حذف مشتری</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanDeleteInfo' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanDeleteInfo
                    " v-model="editItem.tblTafsiliTypeGrp[key].canDeleteInfo" />
                  <label class="custom-control-label Pointer float-right" :for="'CanDeleteInfo' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>مشاهده حسابها</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanViewHesab' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanViewHesab
                    " v-model="editItem.tblTafsiliTypeGrp[key].canViewHesab" />
                  <label class="custom-control-label Pointer float-right" :for="'CanViewHesab' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>ایجاد حسابها</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanInsertHesab' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanInsertHesab
                    " v-model="editItem.tblTafsiliTypeGrp[key].canInsertHesab" />
                  <label class="custom-control-label Pointer float-right" :for="'CanInsertHesab' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>اصلاح حسابها</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanEditHesab' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanEditHesab
                    " v-model="editItem.tblTafsiliTypeGrp[key].canEditHesab" />
                  <label class="custom-control-label Pointer float-right" :for="'CanEditHesab' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>حذف حسابها</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanDeleteHesab' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanDeleteHesab
                    " v-model="editItem.tblTafsiliTypeGrp[key].canDeleteHesab" />
                  <label class="custom-control-label Pointer float-right" :for="'CanDeleteHesab' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>مشاهده تسهیلات</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanViewTashilat' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanViewTashilat
                    " v-model="editItem.tblTafsiliTypeGrp[key].canViewTashilat" />
                  <label class="custom-control-label Pointer float-right" :for="'CanViewTashilat' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>ایجاد تسهیلات</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText"
                    :id="'CanInsertTashilat' + key" @change="statusChk($event, key, index)" :checked="
                      item.CanInsertTashilat
                    " v-model="editItem.tblTafsiliTypeGrp[key].canInsertTashilat" />
                  <label class="custom-control-label Pointer float-right" :for="'CanInsertTashilat' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>اصلاح تسهیلات</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanEditTashilat' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanEditTashilat
                    " v-model="editItem.tblTafsiliTypeGrp[key].canEditTashilat" />
                  <label class="custom-control-label Pointer float-right" :for="'CanEditTashilat' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>حذف تسهیلات</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText"
                    :id="'CanDeleteTashilat' + key" @change="statusChk($event, key, index)" :checked="
                      item.CanDeleteTashilat
                    " v-model="editItem.tblTafsiliTypeGrp[key].canDeleteTashilat" />
                  <label class="custom-control-label Pointer float-right" :for="'CanDeleteTashilat' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>مشاهده سپرده</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanViewSeporde' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanViewSeporde
                    " v-model="editItem.tblTafsiliTypeGrp[key].canViewSeporde" />
                  <label class="custom-control-label Pointer float-right" :for="'CanViewSeporde' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>ایجاد سپرده</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText"
                    :id="'CanInsertSeporde' + key" @change="statusChk($event, key, index)" :checked="
                      item.CanInsertSeporde
                    " v-model="editItem.tblTafsiliTypeGrp[key].canInsertSeporde" />
                  <label class="custom-control-label Pointer float-right" :for="'CanInsertSeporde' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>اصلاح سپرده</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanEditSeporde' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanEditSeporde
                    " v-model="editItem.tblTafsiliTypeGrp[key].canEditSeporde" />
                  <label class="custom-control-label Pointer float-right" :for="'CanEditSeporde' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>حذف سپرده</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText"
                    :id="'CanDeleteSeporde' + key" @change="statusChk($event, key, index)" :checked="
                      item.CanDeleteSeporde
                    " v-model="editItem.tblTafsiliTypeGrp[key].canDeleteSeporde" />
                  <label class="custom-control-label Pointer float-right" :for="'CanDeleteSeporde' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>مشاهده چک واگذاری</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanViewCheck' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanViewCheck
                    " v-model="editItem.tblTafsiliTypeGrp[key].canViewCheck" />
                  <label class="custom-control-label Pointer float-right" :for="'CanViewCheck' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>ایجاد چک واگذاری</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanInsertCheck' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanInsertCheck
                    " v-model="editItem.tblTafsiliTypeGrp[key].canInsertCheck" />
                  <label class="custom-control-label Pointer float-right" :for="'CanInsertCheck' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>اصلاح چک واگذاری</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanEditCheck' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanEditCheck
                    " v-model="editItem.tblTafsiliTypeGrp[key].canEditCheck" />
                  <label class="custom-control-label Pointer float-right" :for="'CanEditCheck' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>حذف چک واگذاری</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanDeleteCheck' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanDeleteCheck
                    " v-model="editItem.tblTafsiliTypeGrp[key].canDeleteCheck" />
                  <label class="custom-control-label Pointer float-right" :for="'CanDeleteCheck' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>دریافت پرداخت</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanDarPar' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanDarPar
                    " v-model="editItem.tblTafsiliTypeGrp[key].canDarPar" />
                  <label class="custom-control-label Pointer float-right" :for="'CanDarPar' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>مشاهده تمام اسناد</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanViewAllSanad' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanViewAllSanad
                    " v-model="editItem.tblTafsiliTypeGrp[key].canViewAllSanad" />
                  <label class="custom-control-label Pointer float-right" :for="'CanViewAllSanad' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3 border p-2">
            <div class="row">
              <div class="col-8">
                <small>مشاهده مانده</small>
              </div>
              <div class="col-4 text-right">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="float-left custom-control-input InputText" :id="'CanViewMande' + key"
                    @change="statusChk($event, key, index)" :checked="
                      item.CanViewMande
                    " v-model="editItem.tblTafsiliTypeGrp[key].canViewMande" />
                  <label class="custom-control-label Pointer float-right" :for="'CanViewMande' + key">
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-40">
      <button class="btn btn-success mt-2 col-3 p-1" @click="submit()">
        ثبت
      </button>

    </div>

  </div>
</template>
<script>
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  props: ['idItem', 'dastresi', 'jobName', 'editItem'],
  components: { SearchableCombo },
  data() {
    return {
      list: { BvfrmDastresiPost: [] },
      showNewItem: false,
      createAccessModel: {
        shobeId: null,
        tafsiliTypeID: null,
        grpId: null,
      },
    };
  },
  computed: {},
  methods: {
    getGrp(data) {
      if (data.id != null) {
        this.createAccessModel.grpId = data.id
      }
    },
    getShobe(data) {
      if (data.id != null) {
        this.createAccessModel.shobeId = data.id
      }
    },
    submit() {
      this.$emit('submitTafsiliTypeGrp')
    },
    createAccess() {
      debugger
      if (this.createAccessModel.grpId == null) {
        this.$mySweetDefaultTost("خطا", "سمت باید انتخاب شود", "warning", 1000);
        return
      }

      if (this.createAccessModel.shobeId == null) {
        this.$mySweetDefaultTost(
          "خطا",
          "شعبه باید انتخاب شود",
          "warning",
          1000
        );
        return
      }
      this.createAccessModel.tafsiliTypeID = this.idItem
      let DataAxois = {
        ArryfildValue: this.createAccessModel,
        Action: "DastresiPost/Add",
        Method: "POST",
      }
      this.$PostData(DataAxois).then((data) => {
        if (data.status == "success") {
          this.$mySweetDefaultTost(
            "عملیات موفق",
            "دسترسی جدید با موفقیت ثبت شد",
            "success",
            2000
          );
          this.$emit('addAccesse')
        } else {
          if (data.eNum == 2601) {
            this.$mySweetDefaultTost(
              "خطا",
              "امکان ثبت دسترسی تکراری برای این سمت و شعبه وجود ندارد!",
              "error",
              1000
            );
          } else {
            this.$mySweetDefaultTost("خطا", "خطا در سرور!", "error", 1000);
          }
        }
      })
    },
    toggle(value) {
      var elem = document.getElementById(value);

      if (!elem.classList.contains("collapsed")) {
        elem.classList.add("collapsed");
      } else {
        var all = document.getElementsByClassName("slidetoggle");

        for (const element of all) {
          if (!element.classList.contains("collapsed")) {
            element.classList.add("collapsed");
          }
        }

        // all.forEach((element) => {
        //   if (!element.classList.contains("collapsed")) {
        //     element.classList.add("collapsed");
        //   }
        // });

        if (elem.classList.contains("collapsed")) {
          elem.classList.remove("collapsed");
        } else {
          elem.classList.add("collapsed");
        }
      }
    },
    statusChk: function (event, key) {
      var targetId = event.currentTarget.id;
      var checkBox = document.getElementById(targetId);
      var fieldname = targetId.replace(/[0-9]/g, "");
      // if (checkBox.checked == true) {
      //   this.$store.state.AnvaMoshtarian.EditData[0].TblTafsiliTypeGrp[key][
      //     fieldname
      //   ] = 1;
      // } else {
      //   this.$store.state.AnvaMoshtarian.EditData[0].TblTafsiliTypeGrp[key][
      //     fieldname
      //   ] = 0;
      // }
    },
  },
  created() {
    this.$mySweetDefaultTost("در حال بارگذاری", " ", "warning", "");
    var datasend = {
      Action: "DastresiPost/Index",
      ArryfildValue: { Id: this.idItem },
      Token: this.$session.get("Token"),
      Method: "POST",
    };

    this.$PostData(datasend)
      .then((data) => {
        if (data != null) {
          // this.$store.state.AnvaMoshtarian.EditData[0].TblTafsiliTypeGrp = null;
          var obj = [];
          data.forEach((element) => {
            var clone = Object.assign({}, element);
            delete clone.NameShobe;
            delete clone.Post;
            obj.push(clone);
            // this.list = JSON.parse(
            //   // JSON.stringify(this.$store.state.AnvaMoshtarian.EditData[0])
            // );
            this.list.BvfrmDastresiPost = data;

          });
          // this.list.BvfrmDastresiPost = data;
          // this.$store.state.AnvaMoshtarian.EditData[0].TblTafsiliTypeGrp = obj;
        }

        this.datasemat = data;
      })
      .finally(() => {
        this.$mySweetDefaultTost("بارگذاری موفق", " ", "success", "1000");
      });
  },
  updated: function () {
    this.$emit("checkup", 2);
  },
};
</script>
<style scoped>
.bg-DefModal {
  background: #566787;
}

.nav-link.disabled {
  color: rgb(224, 221, 221);
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #fff;
}

.card-body.collapsed {
  transition: all 0.7s linear;
  max-height: 0;
  overflow: hidden;
}

.card-body:not(.collapsed) {
  max-height: 80vh !important;
  overflow: hidden;
  transition: max-height 1s ease-in !important;
}
</style>
